<div class="d-flex justify-content-center py-4">
    <div class=" w-100">
        <form [formGroup]="mdl_TripSAD" class="modal-body p-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-1"></div>
                    <div class="col-md-6 col-12">
                        <ng-container *ngIf="iState == 1">
                            <!-- Step 1: Trip Details -->
                            <div class="card border-0 shadow-sm rounded-4 mb-4">
                                <div class="card-body p-md-4 p-2">

                                    <!-- Trip Information -->
                                    <div class="section-title alert alert-primary p-0 mb-3">
                                        <h4 class="fw-bold mb-0 py-1 text-dark d-flex align-items-center gap-2">
                                            <i class="pe-2 fa fa-info-circle fa-lg"></i>
                                            اطلاعات سفر
                                        </h4>
                                    </div>

                                    <div class="row g-3 mb-3">
                                        <div class="col-md-6">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500"> کد ملی </label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">badge</mat-icon>
                                                </span>
                                                <input (input)="filterNumericInput($event)" inputmode="numeric"
                                                    maxlength="10" formControlName="strID"
                                                    class="form-control custom-input" type="text"
                                                    placeholder=" مثال : 0024212345">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group has-icon">
                                                <label class="text-muted m-0 fw-500">تعداد مسافران </label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">groups</mat-icon>
                                                </span>
                                                <select class="w-100 custom-select" formControlName="tiPassenger">
                                                    <option value="1"> 1 نفر </option>
                                                    <option value="2"> 2 نفر </option>
                                                    <option value="3"> 3 نفر </option>
                                                    <option value="4"> 4 نفر </option>
                                                    <option value="12"> 12 نفر </option>
                                                    <option value="17"> 17 نفر </option>
                                                    <option value="25"> 25 نفر </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row g-3 mb-3">
                                        <div class="col-md-6">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500"> تاریخ </label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">date_range</mat-icon>
                                                </span>
                                                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                                    [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                                    <input style="background: #fff !important;" readonly type="text"
                                                        formControlName="strDate"
                                                        class="form-control custom-input text-end" placeholder=""
                                                        autocomplete="off" initialValue="false" />
                                                </ng-persian-datepicker>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500"> ساعت </label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">schedule</mat-icon>
                                                </span>
                                                <input placeholder="ساعت" formControlName="strTime" required
                                                    class="form-control custom-input" [format]="24"
                                                    [ngxTimepicker]="picker" readonly>
                                                <ngx-material-timepicker #picker [cancelBtnTmpl]="cancelBtn"
                                                    [confirmBtnTmpl]="confirmBtn">
                                                </ngx-material-timepicker>

                                                <ng-template #cancelBtn>
                                                    <button class="Btn_timePicker"
                                                        style="margin-right: 10px;background-color: #ff0000;">لغو</button>
                                                </ng-template>
                                                <ng-template #confirmBtn>
                                                    <button class="Btn_timePicker"
                                                        style="background-color: #009620;">تایید</button>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Cities -->
                                    <div class="section-title alert alert-primary p-0 mb-3">
                                        <h4 class="fw-bold mb-0 py-1 text-dark d-flex align-items-center gap-2">
                                            <i class="pe-2 fa fa-road"></i>
                                            مسیر سفر
                                        </h4>
                                    </div>

                                    <div class="row g-3 mb-3">
                                        <div class="col-md-6">
                                            <div class="position-relative w-100">
                                                <label class="text-muted m-0 fw-500"> شهر مبدا </label>
                                                <custom-filter *ngIf="list_City.length"
                                                    [strValue]="getCityNameById(mdl_TripSAD.get('strSCity')?.value, list_City, 'strCityName')"
                                                    [strComment]="'strCityName'"
                                                    [stylesArray]="['padding-top: 10px','text-align: center']"
                                                    [str_Placeholder]="' جستجو کنید'" [lst_Main]="list_City"
                                                    [lst_SearchKey]="['strCityName']" [isDisabled]="false"
                                                    (hideOptions)="setValue_Filter($event,'strSCity')">
                                                </custom-filter>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="position-relative w-100">
                                                <label class="text-muted m-0 fw-500"> شهر مقصد </label>
                                                <custom-filter
                                                    [strValue]="getCityNameById(mdl_TripSAD.get('strDCity')?.value, list_City, 'strCityName')"
                                                    [strComment]="'strCityName'"
                                                    [stylesArray]="['padding-top: 10px','text-align: center']"
                                                    [str_Placeholder]="'   جستجو کنید'" [lst_Main]="list_City"
                                                    [lst_SearchKey]="['strCityName']" [isDisabled]="false"
                                                    (hideOptions)="setValue_Filter($event,'strDCity')">
                                                </custom-filter>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Addresses -->
                                    <div class="mb-3">
                                        <label class="text-muted fw-500"> آدرس مبداء </label>
                                        <div class="position-relative">
                                            <input class="form-control custom-input p-2 input-start"
                                                placeholder="آدرس دقیق همراه پلاک، بلوک و ..."
                                                formControlName="strSAddress">
                                            <button class="btn btn-warning rounded-end"
                                                (click)="openMap('strSAddress')">
                                                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <ng-container *ngIf="mdl_TripSAD.get('fSLon')?.errors?.['required']">
                                            <small class="text-danger">موقعیت دقیق مبداء را از روی نقشه انتخاب
                                                کنید.</small>
                                        </ng-container>
                                    </div>

                                    <div class="mb-4">
                                        <label class="text-muted fw-500"> آدرس مقصد </label>
                                        <div class="position-relative">
                                            <input class="form-control custom-input p-2 input-start"
                                                placeholder="آدرس دقیق همراه پلاک، بلوک و ..."
                                                formControlName="strDAddress">
                                            <button class="btn btn-warning rounded-end"
                                                (click)="openMap('strDAddress')">
                                                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <ng-container *ngIf="mdl_TripSAD.get('fDLon')?.errors?.['required']">
                                            <small class="text-danger">موقعیت دقیق مقصد را از روی نقشه انتخاب
                                                کنید.</small>
                                        </ng-container>
                                    </div>

                                    <!-- Trip Options -->
                                    <div class="section-title alert alert-primary p-0 mb-3">
                                        <h4 class="fw-bold mb-0 py-1 text-dark d-flex align-items-center gap-2">
                                            <i class="pe-2 fa fa-sliders"></i>
                                            اطلاعات تکمیلی
                                        </h4>
                                    </div>

                                    <div class="trip-options row g-3 mb-3">

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <mat-checkbox style="text-align: left;" formControlName="bCameBack"
                                                type="checkbox" required>
                                                <span class="ms-2">رفت و برگشت</span>
                                            </mat-checkbox>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <mat-checkbox (change)="visiblityForAnother()" style="text-align: left;"
                                                formControlName="bForAnother" type="checkbox" required>
                                                <span class="ms-2">برای دیگری</span>
                                            </mat-checkbox>
                                        </div>

                                        <div *ngIf="bForAnother" class="col-12 animate-slide-down mb-2">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500"> نام و نام خانوادگی مسافر
                                                </label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">person_add</mat-icon>
                                                </span>
                                                <input formControlName="strPassengersName"
                                                    class="form-control custom-input" type="text" placeholder=" ">
                                            </div>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <mat-checkbox (change)="visiblityHasStop()" style="text-align: left;"
                                                formControlName="bHasStop" type="checkbox" required>
                                                <span class="ms-2">دارای توقف</span>
                                            </mat-checkbox>
                                        </div>

                                        <div *ngIf="bHasStop" class="col-12 animate-slide-down mb-2">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500"> مقدار توقف (ساعت) </label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">timer</mat-icon>
                                                </span>
                                                <input maxlength="4" formControlName="fEstimateStop"
                                                    class="form-control custom-input" type="text"
                                                    placeholder=" مثال : 3.5 ">
                                            </div>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <mat-checkbox (change)="visiblityCargo()" style="text-align: left;"
                                                formControlName="bCargo" type="checkbox" required>
                                                <span class="ms-2">بار دارم</span>
                                            </mat-checkbox>
                                        </div>

                                        <div *ngIf="bCargo" class="col-12 animate-slide-down mb-2">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500">توضیحات بار</label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">luggage</mat-icon>
                                                </span>
                                                <input formControlName="strCargoDetail"
                                                    class="form-control custom-input input-start" type="text"
                                                    placeholder=" مثال : دو چمدان و یک کوله">
                                            </div>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <div class="option-card rounded-3 text-end"
                                                [class.selected]="mdl_TripSAD.get('bPet')?.value">
                                                <mat-checkbox formControlName="bPet" type="checkbox" required>
                                                    <span class="ms-1">حیوان خانگی</span>
                                                </mat-checkbox>
                                            </div>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <div class="option-card rounded-3 text-end"
                                                [class.selected]="mdl_TripSAD.get('bSmoking')?.value">
                                                <mat-checkbox formControlName="bSmoking" type="checkbox" required>
                                                    <span class="ms-1">سیگار</span>
                                                </mat-checkbox>
                                            </div>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <div class="option-card rounded-3 text-end"
                                                [class.selected]="mdl_TripSAD.get('bNeedHelp')?.value">
                                                <mat-checkbox formControlName="bNeedHelp" type="checkbox" required>
                                                    <span class="ms-1">نیاز به کمک</span>
                                                </mat-checkbox>
                                            </div>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <mat-checkbox (change)="visiblityInvoiceRequired()"
                                                style="text-align: left;" formControlName="bInvoiceRequired"
                                                type="checkbox" required>
                                                <span class="ms-2">فاکتور نیاز دارم</span>
                                            </mat-checkbox>
                                        </div>

                                        <div *ngIf="bInvoiceRequired" class="col-12 animate-slide-down mb-2">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500"> نام شرکت یا شخص</label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">receipt</mat-icon>
                                                </span>
                                                <input formControlName="strCompany"
                                                    class="form-control custom-input input-start" type="text"
                                                    placeholder="مثال : شرکت رایان اندیشه نصر ">
                                            </div>
                                        </div>

                                        <div
                                            class="col-md-4 col-6 form-check custom-checkbox mb-2 p-2 rounded-3 bg-light">
                                            <mat-checkbox (change)="visiblityForeigner()" style="text-align: left;"
                                                formControlName="bForeigner" type="checkbox" required>
                                                <span class="ms-2">اتباع غیر ایرانی</span>
                                            </mat-checkbox>
                                        </div>

                                        <div *ngIf="bForeigner" class="col-12 animate-slide-down mb-2">
                                            <div class="form-group w-100 has-icon">
                                                <label class="text-muted m-0 fw-500"> شماره پاسپورت مسافر </label>
                                                <span class="form-control-icon">
                                                    <mat-icon class="mat-18">public</mat-icon>
                                                </span>
                                                <input maxlength="9" formControlName="strPassportNumber"
                                                    class="form-control custom-input" type="text"
                                                    placeholder=" مثال : A12345678 ">
                                            </div>
                                        </div>

                                    </div>

                                    <!-- Comment -->
                                    <div class="form-group w-100 has-icon mb-3">
                                        <span class="form-control-icon">
                                            <mat-icon class="mat-18">comment</mat-icon>
                                        </span>
                                        <textarea style="height: 70px;" class="w-100 mb-3 form-control custom-input"
                                            formControlName="strComment"
                                            placeholder="هرگونه مطلب مهم را اینجا بنویسید"></textarea>
                                    </div>

                                    <!-- Submit Button -->
                                    <div class="d-flex justify-content-end">
                                        <button (click)="changeState(2)"
                                            class="btn btn-primary btn-md px-4 rounded-pill shadow-sm">
                                            مرحله بعدی
                                            <i class="fa fa-arrow-left me-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="iState == 2">
                            <!-- Step 2: Select Car Type -->
                            <div class="card border-0 shadow-sm rounded-4 mb-4">
                                <div class="card-body p-md-4 p-2">
                                    <div class="section-title text-center alert alert-primary p-0 mb-3 pt-2">
                                        <i class="fa fa-car fa-3x ms-2"></i>
                                        <h5 class="fw-bold text-center text-dark pt-2 mb-1">
                                            انتخاب نوع خودرو
                                        </h5>
                                        <p class="text-muted text-center small">خودروی مورد نظر خود را انتخاب کنید
                                        </p>
                                    </div>

                                    <div [formGroup]="mdl_TripSAD" class="choose-car mb-3">

                                        <div class="car-option mb-3 p-1 px-3 rounded-4 border"
                                            [class.bg-primary-light]="mdl_TripSAD.get('tiMobileGroup')?.value === 1">
                                            <label class=" d-flex align-items-center cursor-pointer w-100"
                                                for="furnished-0">
                                                <input type="radio" id="furnished-0" formControlName="tiMobileGroup"
                                                    [value]="1" style="display: none;">
                                                <div class="car-icon ms-3">
                                                    <img class="fill" src="../../../assets/imgs/car-sedan-fill.png"
                                                        alt="Sedan">
                                                    <img class="nofill" src="../../../assets/imgs/car-sedan.png"
                                                        alt="Sedan">
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h4 class="mb-1 fw-bold">اقتصادی</h4>
                                                    <p class="text-muted mb-0 small">مناسب برای سفرهای روزانه</p>
                                                </div>
                                                <div class="text-end">
                                                    <div class="price-tag">
                                                        <span class="h5 text-success fw-bold">{{prices[0]?.iRent |
                                                            number: '1.0-0' | faNum}}</span>
                                                        <span class="text-muted small">ریال</span>
                                                    </div>
                                                    <ng-container *ngIf="prices[0]?.iDiscount > 0">
                                                        <small class="text-danger d-block">
                                                            <i class="fa fa-tag ms-1"></i>
                                                            تخفیف : {{ prices[0]?.iDiscount | number: '1.0-0' |
                                                            faNum}} ریال
                                                        </small>
                                                    </ng-container>
                                                </div>
                                            </label>
                                        </div>

                                        <div class="car-option mb-3 p-1 px-3 rounded-4 border"
                                            [class.bg-primary-light]="mdl_TripSAD.get('tiMobileGroup')?.value === 2">
                                            <label class=" d-flex align-items-center cursor-pointer w-100"
                                                for="furnished-5">
                                                <input type="radio" id="furnished-5" formControlName="tiMobileGroup"
                                                    [value]="2" style="display: none;">
                                                <div class="car-icon ms-3">
                                                    <img class="fill" src="../../../assets/imgs/eco-fill.png" alt="Eco">
                                                    <img class="nofill" src="../../../assets/imgs/car-eco.png"
                                                        alt="Eco">
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h4 class="mb-1 fw-bold">اقتصادی ویژه</h4>
                                                    <p class="text-muted mb-0 small">امکانات بیشتر، راحتی بهتر</p>
                                                </div>
                                                <div class="text-end">
                                                    <div class="price-tag">
                                                        <span class="h5 text-success fw-bold">{{prices[1]?.iRent |
                                                            number: '1.0-0' | faNum}}</span>
                                                        <span class="text-muted small">ریال</span>
                                                    </div>
                                                    <ng-container *ngIf="prices[1]?.iDiscount > 0">
                                                        <small class="text-danger d-block">
                                                            <i class="fa fa-tag ms-1"></i>
                                                            تخفیف : {{ prices[1]?.iDiscount | number: '1.0-0' |
                                                            faNum}} ریال
                                                        </small>
                                                    </ng-container>
                                                </div>
                                            </label>
                                        </div>

                                        <div class="car-option mb-3 p-1 px-3 rounded-4 border"
                                            [class.bg-primary-light]="mdl_TripSAD.get('tiMobileGroup')?.value === 3">
                                            <label class=" d-flex align-items-center cursor-pointer w-100"
                                                for="furnished-1">
                                                <input type="radio" id="furnished-1" formControlName="tiMobileGroup"
                                                    [value]="3" style="display: none;">
                                                <div class="car-icon ms-3">
                                                    <img class="fill" src="../../../assets/imgs/car-lux-fill.png"
                                                        alt="VIP">
                                                    <img class="nofill" src="../../../assets/imgs/car-lux.png"
                                                        alt="VIP">
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h4 class="mb-1 fw-bold text-success">
                                                        <i class="fa fa-diamond"></i>
                                                        VIP
                                                    </h4>
                                                    <p class="text-muted mb-0 small">تجربه لوکس سفر</p>
                                                </div>
                                                <div class="text-end">
                                                    <div class="price-tag">
                                                        <span class="h5 text-success fw-bold">{{prices[2]?.iRent |
                                                            number: '1.0-0' | faNum}}</span>
                                                        <span class="text-muted small">ریال</span>
                                                    </div>
                                                    <ng-container *ngIf="prices[2]?.iDiscount > 0">
                                                        <small class="text-danger d-block">
                                                            <i class="fa fa-tag ms-1"></i>
                                                            تخفیف : {{ prices[2]?.iDiscount | number: '1.0-0' |
                                                            faNum}} ریال
                                                        </small>
                                                    </ng-container>
                                                </div>
                                            </label>
                                        </div>

                                        <div class="car-option mb-3 p-1 px-3 rounded-4 border"
                                            [class.bg-primary-light]="mdl_TripSAD.get('tiMobileGroup')?.value === 4">
                                            <label class=" d-flex align-items-center cursor-pointer w-100"
                                                for="furnished-2">
                                                <input type="radio" id="furnished-2" formControlName="tiMobileGroup"
                                                    [value]="4" style="display: none;">
                                                <div class="car-icon ms-3">
                                                    <img class="fill" src="../../../assets/imgs/suv-car-fill.png"
                                                        alt="SUV">
                                                    <img class="nofill" src="../../../assets/imgs/suv-car.png"
                                                        alt="SUV">
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h4 class="mb-1 fw-bold">SUV</h4>
                                                    <p class="text-muted mb-0 small">فضای بیشتر، راحتی بیشتر</p>
                                                </div>
                                                <div class="text-end">
                                                    <div class="price-tag">
                                                        <span class="h5 text-success fw-bold">{{prices[3]?.iRent |
                                                            number: '1.0-0' | faNum}}</span>
                                                        <span class="text-muted small">ریال</span>
                                                    </div>
                                                    <ng-container *ngIf="prices[3]?.iDiscount > 0">
                                                        <small class="text-danger d-block">
                                                            <i class="fa fa-tag ms-1"></i>
                                                            تخفیف : {{ prices[3]?.iDiscount | number: '1.0-0' |
                                                            faNum}} ریال
                                                        </small>
                                                    </ng-container>
                                                </div>
                                            </label>
                                        </div>

                                        <div class="car-option mb-3 p-1 px-3 rounded-4 border"
                                            [class.bg-primary-light]="mdl_TripSAD.get('tiMobileGroup')?.value === 5">
                                            <label class=" d-flex align-items-center cursor-pointer w-100"
                                                for="furnished-3">
                                                <input type="radio" id="furnished-3" formControlName="tiMobileGroup"
                                                    [value]="5" style="display: none;">
                                                <div class="car-icon ms-3">
                                                    <img class="fill" src="../../../assets/imgs/car-van-fill.png"
                                                        alt="Van">
                                                    <img class="nofill" src="../../../assets/imgs/car-van.png"
                                                        alt="Van">
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h4 class="mb-1 fw-bold">ون و مینی ون</h4>
                                                    <p class="text-muted mb-0 small">مناسب برای گروه‌های بزرگ</p>
                                                </div>
                                                <div class="text-end">
                                                    <div class="price-tag">
                                                        <span class="h5 text-success fw-bold">{{prices[4]?.iRent |
                                                            number: '1.0-0' | faNum}}</span>
                                                        <span class="text-muted small">ریال</span>
                                                    </div>
                                                    <ng-container *ngIf="prices[4]?.iDiscount > 0">
                                                        <small class="text-danger d-block">
                                                            <i class="fa fa-tag ms-1"></i>
                                                            تخفیف : {{ prices[4]?.iDiscount | number: '1.0-0' |
                                                            faNum}} ریال
                                                        </small>
                                                    </ng-container>
                                                </div>
                                            </label>
                                        </div>

                                    </div>

                                    <!-- Navigation Buttons -->
                                    <div class="d-flex justify-content-between pt-3 border-top">
                                        <button (click)="changeState(1)"
                                            class="btn btn-outline-secondary btn-md px-3 rounded-pill">
                                            <i class="fa fa-arrow-right ms-2"></i>
                                            مرحله قبلی
                                        </button>
                                        <button (click)="changeState(3)"
                                            class="btn btn-primary btn-md px-4 rounded-pill shadow-sm">
                                            تایید و ادامه
                                            <i class="fa fa-arrow-left me-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="iState == 3">
                            <!-- Step 3: Invoice & Confirmation -->
                            <div class="card border-0 shadow-sm rounded-4 mb-2">
                                <div class="card-body p-md-4 p-2">
                                    <!-- Invoice Header -->
                                    <div class="invoice-header text-center mb-2 pb-4 border-bottom">
                                        <h3 class="fw-bold text-dark mb-1">پیش فاکتور</h3>
                                    </div>

                                    <!-- Invoice Details -->
                                    <div class="invoice_details mb-2">
                                        <div class="detail-row d-flex justify-content-between py-3 border-bottom">
                                            <span class="text-muted fw-500">
                                                <i class="fa fa-map-marker fa-lg text-danger ms-2"></i>
                                                مبداء
                                            </span>
                                            <span class="fw-bold">{{invoice?.strSCityComment}}</span>
                                        </div>
                                        <div class="detail-row d-flex justify-content-between py-3 border-bottom">
                                            <span class="text-muted fw-500">
                                                <i class="fa fa-map-marker fa-lg text-success ms-2"></i>
                                                مقصد
                                            </span>
                                            <span class="fw-bold">{{invoice?.strDCityComment }}</span>
                                        </div>
                                        <div class="detail-row d-flex justify-content-between py-3 border-bottom">
                                            <span class="text-muted fw-500">
                                                <i class="fa fa-calendar fa-lg ms-2"></i>
                                                تاریخ و ساعت
                                            </span>
                                            <span class="fw-bold">{{invoice?.strTime | faNum}} - {{invoice?.strDate
                                                | faNum}}</span>
                                        </div>
                                        <div class="detail-row d-flex justify-content-between py-3 border-bottom">
                                            <span class="text-muted fw-500">
                                                <i class="fa fa-users fa-lg ms-2"></i>
                                                تعداد مسافر
                                            </span>
                                            <span class="fw-bold">{{invoice?.tiPassenger | faNum}} نفر</span>
                                        </div>
                                        <div class="detail-row d-flex justify-content-between py-3 border-bottom">
                                            <span class="text-muted fw-500">
                                                <i class="fa fa-car fa-lg ms-2"></i>
                                                نوع خودرو
                                            </span>
                                            <span class="fw-bold">
                                                <span *ngIf="invoice?.tiMobileGroup == 1">اقتصادی </span>
                                                <span *ngIf="invoice?.tiMobileGroup == 2">اقتصادی ویژه </span>
                                                <span *ngIf="invoice?.tiMobileGroup == 3">VIP </span>
                                                <span *ngIf="invoice?.tiMobileGroup == 4">SUV </span>
                                                <span *ngIf="invoice?.tiMobileGroup == 5">ون و مینی ون </span>
                                            </span>
                                        </div>
                                        <div
                                            class="detail-row d-flex justify-content-between py-3 border-bottom bg-light rounded-3 px-3 my-2">
                                            <span class="text-muted fw-500">
                                                <i class="fa fa-money fa-lg text-dark ms-2"></i>
                                                پیش پرداخت
                                            </span>
                                            <span class="fw-bold text-dark">{{ invoice?.iAdvancePayment | number:
                                                '1.0-0' | faNum}} ریال </span>
                                        </div>
                                        <div
                                            class="detail-row d-flex justify-content-between py-3 border-bottom bg-success-light rounded-3 px-3 my-2">
                                            <span class="text-muted fw-500">
                                                <i class="fa fa-wallet text-success ms-2"></i>
                                                کرایه کل
                                            </span>
                                            <span class="h5 text-success fw-bold">{{ invoice?.iPrice | number:
                                                '1.0-0' | faNum}} ریال </span>
                                        </div>
                                    </div>

                                    <!-- Trip Options Icons -->
                                    <div *ngIf="hasOptions() > 0"
                                        class="trip-options-icons d-flex flex-wrap justify-content-center gap-3 mb-2 p-3 bg-light rounded-4">
                                        <div *ngIf="invoice?.bCameBack"
                                            class="option-badge bg-warning text-dark p-2 rounded-3">
                                            <mat-icon class="mat-18">refresh</mat-icon>
                                            <span class="ms-1">رفت و برگشت</span>
                                        </div>
                                        <div *ngIf="invoice?.bHasStop"
                                            class="option-badge bg-warning text-dark p-2 rounded-3">
                                            <mat-icon class="mat-18">timer</mat-icon>
                                            <span class="ms-1">توقف ({{invoice?.fEstimateStop | faNum}}) </span>
                                        </div>
                                        <div *ngIf="invoice?.bCargo"
                                            class="option-badge bg-warning text-dark p-2 rounded-3">
                                            <mat-icon class="mat-18">luggage</mat-icon>
                                            <span class="ms-1">چمدان </span>
                                        </div>
                                        <div *ngIf="invoice?.bPet"
                                            class="option-badge bg-warning text-dark p-2 rounded-3">
                                            <mat-icon class="mat-18">pets</mat-icon>
                                            <span class="ms-1">حیوانات </span>
                                        </div>
                                        <div *ngIf="invoice?.bNeedHelp"
                                            class="option-badge bg-warning text-dark p-2 rounded-3">
                                            <mat-icon class="mat-18">accessible</mat-icon>
                                            <span class="ms-1">کمک </span>
                                        </div>
                                        <div *ngIf="invoice?.bSmoking"
                                            class="option-badge bg-warning text-dark p-2 rounded-3">
                                            <mat-icon class="mat-18">smoking_rooms</mat-icon>
                                            <span class="ms-1">سیگار </span>
                                        </div>
                                    </div>

                                    <!-- Accordion -->
                                    <mat-accordion class="custom-accordion mb-2">
                                        <mat-expansion-panel class="rounded-3 mb-2 shadow-sm">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <b class="d-flex align-items-center">
                                                        <mat-icon class="mat-18 ms-2">info</mat-icon>
                                                        شرایط لغو سفر
                                                    </b>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>
                                            <div class="p-3">
                                                <p class="text-danger fw-bold mb-3">
                                                    <i class="fa fa-exclamation-triangle ms-2"></i>
                                                    رزرو های فوری (زیر ۴ ساعت) امکان بازگشت وجه ندارد
                                                </p>
                                                <p class="text-danger fw-bold mb-3">
                                                    <i class="fa fa-exclamation-triangle ms-2"></i>
                                                    درصورت واگذاری سفر به راننده و تماس ایشان امکان کنسلی نیست (۱۰۰٪
                                                    خسارت)
                                                </p>
                                                <ul class="list-group list-group-flush">
                                                    <li
                                                        class="list-group-item d-flex justify-content-between align-items-center">
                                                        <span>تا ۱۰ دقیقه بعد از واریز بیعانه</span>
                                                        <span class="badge bg-success rounded-pill">۰٪ خسارت</span>
                                                    </li>
                                                    <li
                                                        class="list-group-item d-flex justify-content-between align-items-center">
                                                        <span>از ۲۴ تا ۱۲ ساعت قبل از تایم حرکت</span>
                                                        <span class="badge bg-warning text-dark rounded-pill">۳۰٪
                                                            خسارت</span>
                                                    </li>
                                                    <li
                                                        class="list-group-item d-flex justify-content-between align-items-center">
                                                        <span>از ۱۲ تا ۶ ساعت قبل از تایم حرکت</span>
                                                        <span class="badge bg-info text-white rounded-pill">۵۰٪
                                                            خسارت</span>
                                                    </li>
                                                    <li
                                                        class="list-group-item d-flex justify-content-between align-items-center">
                                                        <span>از ۶ تا ۴ ساعت قبل از تایم حرکت</span>
                                                        <span class="badge bg-danger rounded-pill">۸۰٪ خسارت</span>
                                                    </li>
                                                    <li
                                                        class="list-group-item d-flex justify-content-between align-items-center">
                                                        <span>کمتر از ۴ ساعت به تایم حرکت</span>
                                                        <span class="badge bg-dark rounded-pill">۱۰۰٪ خسارت</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </mat-expansion-panel>

                                        <mat-expansion-panel class="rounded-3 mb-2 shadow-sm">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <b class="d-flex align-items-center">
                                                        <mat-icon class="mat-18 ms-2">luggage</mat-icon>
                                                        شرایط بار
                                                    </b>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>
                                            <div class="p-3">
                                                <ul class="list-unstyled">
                                                    <li class="mb-2"><i
                                                            class="fa fa-check-circle text-success ms-2"></i>ظرفیت
                                                        خودروهای اکونومی گازسوز: ۱ چمدان بزرگ و ۱ کوچک</li>
                                                    <li class="mb-2"><i
                                                            class="fa fa-check-circle text-success ms-2"></i>ظرفیت
                                                        خودروهای اکونومی تکسوز: ۲ چمدان بزرگ</li>
                                                    <li class="mb-2"><i
                                                            class="fa fa-check-circle text-success ms-2"></i>ظرفیت
                                                        خودروهای لوکس: ۲ چمدان بزرگ و ۱ کوچک</li>
                                                </ul>
                                                <p class="text-muted small mt-3">
                                                    <i class="fa fa-info-circle ms-2"></i>
                                                    در صورت وجود اضافه بار حتما به راننده قبل از حرکت اطلاع داده شود
                                                </p>
                                            </div>
                                        </mat-expansion-panel>

                                        <mat-expansion-panel class="rounded-3 shadow-sm">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <b class="d-flex align-items-center">
                                                        <mat-icon class="mat-18 ms-2">people</mat-icon>
                                                        ظرفیت تعداد نفرات
                                                    </b>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>
                                            <div class="p-3">
                                                <p>ظرفیت همه خودروها ۳ بزرگسال و ۱ کودک زیر ۱۲ سال هست</p>
                                                <p>در صورت ۴ نفر بزرگسال ۱۰٪ به کل مبلغ سفر اضافه میشود</p>
                                                <p class="text-muted small">
                                                    <i class="fa fa-exclamation-circle ms-2"></i>
                                                    به دلیل مسایل بیمه و پلیس راه به هیچ وجه بالای ۴ نفر امکان پذیر
                                                    نمی باشد
                                                </p>
                                            </div>
                                        </mat-expansion-panel>
                                    </mat-accordion>

                                    <!-- Navigation Buttons -->
                                    <div class="d-flex justify-content-between pt-3 border-top">
                                        <button (click)="changeState(2)"
                                            class="btn btn-outline-secondary btn-md px-3 rounded-pill">
                                            <i class="fa fa-arrow-right ms-2"></i>
                                            مرحله قبلی
                                        </button>
                                        <button (click)="tripSubmit()"
                                            class="btn btn-success btn-md px-3 rounded-pill shadow-sm">
                                            ثبت نهایی سفر
                                            <i class="fa fa-check fa-lg me-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="iState == 4">
                            <div class=" d-flex flex-column justify-content-center align-items-center" style="height: 85vh;">
                                <div class="spinner-border spinner-lg" role="status" aria-label="Loading">
                                    <span class="visually-hidden">لطفا منتظر بمانید...</span>
                                </div>
                                <h3 class="mt-3">لطفا منتظر بمانید...</h3>
                            </div>
                        </ng-container>

                    </div>
                    <div class="col-md-3 col-1"></div>
                </div>
            </div>
        </form>
    </div>
</div>

<app-custom-map *ngIf="showCustom_Map" [strValue]="mdl_Map.get('strAddress')?.value"
    [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true"
    (mdl_Submit)="submitMap($event)">
</app-custom-map>

<!-- ثبت نظر -->
<div class="modal fade" id="Voting_Modal" tabindex="4" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title m-0"> نظرسنجی </h2>
                <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body px-md-4 px-2">
                <h3 style="line-height: 30px;"> لطفا نظر خود را در خصوص آخرین سفرتان از
                    <span class="fw-bold"> {{ mdl_Voting.get('strSCityName')?.value }} </span>
                    به <span class="fw-bold"> {{ mdl_Voting.get('strDCityName')?.value }} </span>
                    در تاریخ <span class="fw-bold"> {{ mdl_Voting.get('strDate')?.value | faNum }} </span>
                    بفرمایید.
                    <br>
                    این نظر در بخش نظرات تاکسی لون به سایر مسافرین نمایش داده می شود.
                </h3>
                <div [formGroup]="mdl_Voting">

                    <span class="text-large">

                        میزان رضایت خود از سفر را وارد نمایید

                    </span>

                    <div class="my-3">

                        <star-rating [starType]="'svg'" [rating]="0"
                            (ratingChange)="mdl_Voting.get('iDriverPoints')?.setValue($event)">

                        </star-rating>

                    </div>

                    <ng-container *ngIf="mdl_Voting.get('iDriverPoints')?.value != ''">

                        <div class="p-1">

                            <textarea class="w-100 form-control" style="height: 100px;"
                                placeholder="نظر خود را در رابطه با این سفر جهت نمایش در بخش نظرات تاکسی لون بفرمایید."
                                formControlName="strPassengerOpinion">

                            </textarea>

                        </div>

                    </ng-container>

                </div>

            </div>
            <div dir="ltr" class="modal-footer">
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">
                    بستن
                </button>
                <button class="btn btn-success px-3 pointer" (click)="submitVote()">
                    &nbsp; ثبت &nbsp;
                </button>
            </div>
        </div>
    </div>
</div>